import type { ComponentProps } from "react";
import { cn } from "@/lib/utils";

export function Input({ className, type = "text", ...props }: ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "h-11 w-full min-w-0 rounded-lg border border-input bg-card px-3 text-[15px] text-foreground placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive",
        className,
      )}
      {...props}
    />
  );
}

/** Input nominal Rupiah dengan awalan "Rp" dan angka rata kanan. */
export function MoneyInput({ className, ...props }: Omit<ComponentProps<"input">, "type">) {
  return (
    <div
      className={cn(
        "flex h-11 items-stretch overflow-hidden rounded-lg border border-input bg-card focus-within:outline-2 focus-within:outline-offset-2 focus-within:outline-ring",
        className,
      )}
    >
      <span className="flex items-center border-r bg-muted px-3 text-sm text-muted-foreground">Rp</span>
      <input
        type="text"
        inputMode="numeric"
        data-slot="money-input"
        className="num min-w-0 flex-1 bg-transparent px-3 text-right text-[15px] text-foreground outline-none"
        {...props}
      />
    </div>
  );
}
